<template>
  <div>
    <span class="razon-social" v-tooltip="'Razón Social Receptor'">
      {{ documento.razonSocialReceptor }}
    </span>
    <span class="rut-receptor"> RUT: {{ formatRut(documento.rutReceptor) }}</span>
    <div>
      <vs-chip color="primary" v-tooltip="'Aduana Coordinadora'">
        <span v-if="aduanasCoordinadoras[documento.rutEmisor]">
          {{aduanasCoordinadoras[documento.rutEmisor]}}
        </span>
        <span v-if="!aduanasCoordinadoras[documento.rutEmisor]">
          -
        </span>
      </vs-chip>
      <vs-chip :color="colores.navbar">
        {{ traducitTipoDocumentoEnPalabras(documento.tipoDocumento) }}
      </vs-chip>
      <vs-chip color="#aaa" v-tooltip="'Folio'">
        # {{ documento.folio }}
      </vs-chip>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import TiposDteMixin from '../../mixins/TiposDteMixin';

import { aduanasCoordinadoras } from '@/febos/chile/dte/componentes/campos/aduanas.constants';

export default {
  name: 'CampoDocumentoAduana',
  mixins: [TiposDteMixin],
  data() {
    return {
      aduanasCoordinadoras
    };
  },
  props: {
    documento: {
      type: Object,
    },
  },
  computed: {
    ...mapState('Empresas', {
      empresaActual: (state) => state.empresa,
    }),
    ...mapState('Personalizacion', {
      colores: (state) => state.colores,
    })
  },
  methods: {
    formatRut(rut) {
      const parts = rut.split('-');
      const dv = parts.pop();
      const rest = parts.shift();
      return `${rest.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}-${dv}`;
    }
  }
};
</script>

<style scoped>
  .razon-social{
    font-size:108%;
    font-weight: 400;
  }
  .rut-receptor{
    font-size:90%;
    font-weight: 400;
    margin-left: 15px;
  }
</style>
